import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import type { UpdateStaffRole } from "~pages/Staff/types/staffRole.ts";
import type { RoleResponse } from "~types/role.ts";

export const useUpdateStaffRole = () => {
  const { sport, organizationId, entityId } = useParams();
  const queryClient = useQueryClient();
  const request = useApi();

  return useMutation<RoleResponse, Error, UpdateStaffRole>({
    mutationFn: async ({ roleId, ...body }) =>
      await request<RoleResponse>(`${sport}/o/${organizationId}/roles/${roleId}`, {
        method: "PUT",
        body,
      }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: ["roles", sport, organizationId, entityId],
      });
      await queryClient.invalidateQueries({
        queryKey: ["roles", sport, organizationId],
      });
    },
  });
};
